
import { mdiMinusCircleOutline, mdiPlusCircleOutline } from '@mdi/js'

import FaqMerchantAnswerExec from '../ui/faq/FaqMerchantAnswerExec.vue'
import { StructuredData } from '@/helpers/structuredData'

export default {
  components: { FaqMerchantAnswerExec },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  head () {
    return {
      script: this.script
    }
  },
  icons: { mdiMinusCircleOutline, mdiPlusCircleOutline },
  computed: {
    levelDownTag () {
      return this.section.tag === 'h2' ? 'h3' : 'h4'
    },
    leftAligned () {
      return this.section.leftAligned ? this.section.leftAligned : false
    },

    script () {
      if (this.section.withFAQPageSchema) {
        const sd = new StructuredData()
        return sd.elementsToScriptAndStructuredData(this.section.elements)
      } else {
        return []
      }
    }
  }
}
